module.exports = __webpack_public_path__ + "static/img/hezuo02.483da07.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/imgsrc/hezuo02.jpg
// module id = ohYM
// module chunks = 1